export default __webpack_public_path__ + "static/media/gw.d2c55071.jpg";